<div class="auth-container">
  <div class="form-container px-5 shadow-2 surface-ground-opacity">
    <div class="mb-4"></div>
    <div class="px-sm-4">
      <div class="px-sm-4">
        <div class="w-100">
          <div class="container-logo mb-4 flex flex-column align-items-center">
            <div class="logo-teorema mb-4"></div>
            <div class="d-flex justify-content-end">
              @if (config?.panelTitle && config?.panelTitle != 'V3ndor') {
                <div class="panel-title text-uppercase">
                  {{ config?.panelTitle }}
                </div>
              }
            </div>
          </div>

          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <small class="footer-notes text-right">
      @if (panelTitle) {
        <span> {{ panelTitle }}&nbsp; </span>
      }
      @if (config?.appVersion && config?.repositorySlug) {
        <span>
          <span>
            <a class="link" routerLink="/versoes">{{ config?.appVersion }}</a>
          </span>
        </span>
      }
      @if (config?.env && config?.env != 'production') {
        <span>
          <span class="mx-2">|</span>
          <span class="hidden md:inline">Ambiente&nbsp;</span>
          <patron-badge color="info">
            <span class="capitalize">{{
              config?.env == 'homologation' ? 'Homologação' : config?.env
            }}</span>
          </patron-badge>
        </span>
      }
      <span>
        <span class="mx-2">|</span>
        <span class="hidden md:inline">Powered by&nbsp;</span>
        <a class="link" href="https://www.teorema.inf.br" target="_blank">
          <span>Teorema</span>
        </a>
      </span>
    </small>
  </div>
</div>

<patron-toast></patron-toast>
@if (loadingTheme) {
  <patron-overlay></patron-overlay>
}
